import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotAuthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  // Function to handle the return home button click
  const handleReturnHome = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: "#f5f5f5",
        padding: 3,
      }}
    >
      {/* Display the main heading */}
      <Typography variant="h1" gutterBottom>
        Not Authorized
      </Typography>
      {/* Display the subheading */}
      <Typography variant="h6" gutterBottom>
        You do not have permission to view this page.
      </Typography>
      {/* Render the return home button */}
      <Button variant="contained" color="primary" onClick={handleReturnHome}>
        Return Home
      </Button>
    </Box>
  );
};

export default NotAuthorizedPage;
